/* @flow */

import * as React from 'react';
import {Helmet} from 'react-helmet';

import {MainHeader} from './main-header';
import signupData from './signup';
import {SignupImage} from './signup-image';

import './new-pre-auth-layout.module.css';

export type SignupData = {
    title: string,
    reviewSectionTitle: string,
};

type Props = {|
    form: React.Node,
    isFullScreenForm?: boolean,
|};

export function NewPreAuthLayout(props: Props) {
    const data: SignupData = signupData;

    return (
        <div styleName='grid-container'>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div styleName={props.isFullScreenForm ? '' : 'grid'}>
                {!props.isFullScreenForm && (
                    <>
                        <div styleName='main-header'>
                            <MainHeader />
                        </div>
                        <div styleName='left-content'>
                            <div styleName='header'>{data.title}</div>
                            <div styleName='image-container'>
                                <SignupImage />
                            </div>
                        </div>
                    </>
                )}
                <div key='form' styleName={props.isFullScreenForm ? '' : 'form'}>
                    {props.form}
                </div>
            </div>
        </div>
    );
}
